import { useState, useEffect, useRef } from "react";
import axios from "axios";
import DaysOfWeek from "../../components/DaysOfWeek"; // Import DaysOfWeek component
import CommonErrorMessages from "../../components/CommonErrorMessages"; // Import CommonErrorMessages component
import { useNavigate, useSearchParams } from 'react-router-dom'; // Import useParams
import scrollToTop from '../../utils/scrollToTop';

export const RouteComponent = (provider_guide_id, route_type = 'LIVE') => {
    /* Possible value of route_type: 'LIVE', 'FUTURE' */
    const [searchParams] = useSearchParams();
    const providerType = searchParams.get('providerType');
    const errors = CommonErrorMessages(); // Get the error messages from the CommonErrorMessages component
    const daysOfWeek = DaysOfWeek(); // Get the days of the week from the DaysOfWeek component
    const navigate = useNavigate();

    const [successMessage, setSuccessMessage] = useState('');

    const cfsOriginInputRef = useRef(null);
    const cfsDestinationInputRef = useRef(null);

    const [Route, setRoute] = useState({
        availableBookingCutoffs: [...(daysOfWeek || []), 'ANY'],
        availableCargoCutoffs: [...(daysOfWeek || []), 'ANY'],
        availableCarriers: [],
        availableDocumentationCutoffs: [...(daysOfWeek || []), 'ANY'],
        availablePortOfDischarge: [],
        availablePortOfLoading: [],
        availableServices: [],
        bookingCutoff: 0,
        bookingCutoffTime: { hh: '', mm: '', meridiem: 'AM' },
        cargoAvailabilityWeekday: '',
        cargoCutoff: 0,
        cargoCutoffTime: { hh: '', mm: '', meridiem: 'AM' },
        carrierSections: [],
        cfsDestinationInput: '',
        cfsDestinations: [],
        cfsOriginInput: '',
        cfsOrigins: [],
        coLoadProviders: [],
        combinations: [],
        conversionCancellationSuccess: null,
        conversionError: '',
        conversionSuccess: null,
        converting: false,
        createRoute: { origin: '', destination: '', carrier: '', carrier_service_cutoffs: [] },
        destinationError: '',
        destinationPortCode: '',
        destinationSuggestions: [],
        documentationCutoff: 0,
        documentationCutoffTime: { hh: '', mm: '', meridiem: 'AM' },
        error: '',
        etaWeekday: '',
        etdWeekday: '',
        existingConversionRequest: null,
        invalidPOLPODCarrierServiceCombinationError: '',
        isSaving: false,
        missingPortOfDischargeError: '',
        missingPortOfLoadingError: '',
        missingServiceError: '',
        noPODETAWeekdaysForCarrierServiceCombinationError: '',
        noPOLETDWeekdaysForCarrierServiceCombinationError: '',
        originError: '',
        originSuggestions: [],
        podetaweekdayoptions: [],
        poletdweekdayoptions: [],
        portDwellTime: 0,
        portOfDischarge: '',
        portOfDischargeInput: '',
        portOfLoading: '',
        portOfLoadingInput: '',
        portPairError: '',
        portPairExists: false,
        routeNotFound: false,
        sailingPriority: 'MAIN',
        selectedBookingCutoffs: [],
        selectedCargoCutoffs: [],
        selectedCarrier: null,
        selectedCoLoadProvider: null,
        selectedConversionStartDate: null,
        selectedDocumentationCutoffs: [],
        selectedPortOfDischarge: '',
        selectedPortOfLoading: '',
        selectedService: null,
        showCFSDestinationHelp: false,
        showCFSOriginHelp: false,
        showCoLoadModal: false,
        showCutoffSection: false,
        showSailPriorityHelp: false,
        successMessage: '',
        effectiveDate: null,
        effectiveDateError: null,
        expirationDate: null,
        expirationDateError: null,
        cfsOriginInputRef,
        cfsDestinationInputRef,
        has_future_version: false,
        provider_guide_future_id: null,
        routeType: route_type,
    });

    const handlePortOfLoadingSelect = (e, { suggestion }) => {
        if (suggestion) {
            setRoute(prev => ({
                ...prev,
                portOfLoading: suggestion.port_code,
                selectedPortOfLoading: suggestion.port_code,
                portOfLoadingInput: ''
            }));
        }
    };

    const handlePortOfDischargeSelect = (e, { suggestion }) => {
        if (suggestion) {
            setRoute(prev => ({
                ...prev,
                portOfDischarge: suggestion.port_code,
                selectedPortOfDischarge: suggestion.port_code,
                portOfDischargeInput: ''
            }));
        }
    };

    const handleCarrierServiceSection_ServiceChange = (e, index) => {
        const value = e.target.value;
        const updatedSections = [...Route.carrierSections];
        const section = updatedSections[index];
        section.selectedService = value;
        if (!section.availableServices.includes(value)) {
            section.missingServiceError = errors.VALID_SERVICE_ERROR;
        } else {
            section.missingServiceError = '';
        }

        section.poletdweekdayoptions = [];
        section.podetaweekdayoptions = [];

        const fetchSailingDays = async () => {
            try {
                const response = await axios.get('/api/carrier-service-pol-pod-weekdays-options', {
                    params: {
                        carrier: section.selectedCarrier,
                        service: section.selectedService,
                        pol: Route.selectedPortOfLoading,
                        pod: Route.selectedPortOfDischarge
                    }
                });
                const data = response.data;
                console.log({ data }, "Data received from carrier-service-pol-pod-weekdays-options");
                /* Use the data to populate the POL ETD Weekday and POD ETA Weekday dropdowns */

                /* Filter for data.side == 'POL' to populate poletdweekdayoptions */
                const polOptions = data.filter(item => item.side === 'POL').map(item => item.weekday);
                section.poletdweekdayoptions = polOptions;

                /* Filter for data.side == 'POD' to populate podetaweekdayoptions */
                const podOptions = data.filter(item => item.side === 'POD').map(item => item.weekday);
                section.podetaweekdayoptions = podOptions;

            } catch (error) {
                console.error('Error fetching sailing days:', error);
            }
        };

        if (section.selectedCarrier && section.selectedService && Route.selectedPortOfLoading && Route.selectedPortOfDischarge) {
            fetchSailingDays().then(() => setRoute(prev => ({ ...prev, carrierSections: updatedSections })));
        } else {
            setRoute(prev => ({ ...prev, carrierSections: updatedSections }));
        }

    };

    const handleAddCarrierService = () => {

        // Define sailingPriorityOptions if it's not defined
        const sailingPriorityOptions = [
            { key: 'Main', value: 'MAIN' },
            { key: 'Second Main', value: 'SECOND_MAIN' },
            { key: 'Main Backup', value: 'MAIN_BACKUP' },
            { key: 'Second Main Backup', value: 'SECOND_MAIN_BACKUP' }
        ];

        // Determine which Sailing Priority is available
        const usedPriorities = Route.carrierSections.map(section => section.sailingPriority);
        const foundOption = sailingPriorityOptions.find(option => !usedPriorities.includes(option.value));
        const defaultPriority = (foundOption && foundOption.value ? foundOption.value : sailingPriorityOptions[0].value);

        // Create a new Carrier Service section with a unique Sailing Priority
        const newSection = {
            id: Date.now(), // or any appropriate unique ID generation
            sailingPriority: defaultPriority,
            availableCarriers: [...Route.availableCarriers], // Initialize availableCarriers for this section
            availableServices: [], // Initialize availableServices for this section
            selectedCarrier: '', // Initialize selectedCarrier for this section
            selectedService: '', // Initialize selectedService for this section
            bookingCutoff: 0,
            cargoCutoff: 0,
            documentationCutoff: 0,
            bookingCutoffTime: { hh: '12', mm: '00', meridiem: 'AM' },
            cargoCutoffTime: { hh: '12', mm: '00', meridiem: 'AM' },
            documentationCutoffTime: { hh: '12', mm: '00', meridiem: 'AM' },
            showCutoffSection: false,
            etdWeekday: '',
            etaWeekday: '',
            cargoAvailabilityWeekday: '',
            portDwellTime: 0,
            // ...other default properties...
        };

        setRoute(prev => ({ ...prev, carrierSections: [...prev.carrierSections, newSection] }));
    };

    const handleRemoveCarrierSection = (id) => {
        setRoute(prev => ({ ...prev, carrierSections: Route.carrierSections.filter(section => section.id !== id) }));
    };

    const toggleCutoffSection = (index) => {
        setRoute(prev => ({
            ...prev, carrierSections: prev.carrierSections.map((section, idx) => {
                if (idx === index) {
                    return { ...section, showCutoffSection: !section.showCutoffSection };
                }
                return section;
            })
        }));
    };

    const setTimeFromString = (timeStr) => {
        if (!timeStr) {
            return {
                hh: '12',
                mm: '00',
                meridiem: 'AM',
            };
        }
        const [hour, minute] = timeStr.split(':').map(Number);
        const meridiem = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
        return {
            hh: formattedHour.toString().padStart(2, '0'),
            mm: minute.toString().padStart(2, '0'),
            meridiem,
        };
    };

    const validateForm = () => { // Updated validation function
        let isValid = true;

        if (
            /* !cfsOrigins.length || */ // This is no longer needed because leaving this blank means all cfs origins */
            /* !cfsDestinations.length || */ // This is no longer needed because leaving this blank means all cfs destinations */
            !Route.selectedPortOfLoading ||
            !Route.selectedPortOfDischarge
        ) {
            setRoute(prev => ({ ...prev, error: errors.ALL_FIELDS_REQUIRED }));
            isValid = false;
        } else {
            setRoute(prev => ({ ...prev, error: '' }));
        }

        // Validate integer fields
        if (!Number.isInteger(Route.bookingCutoff)) {
            setRoute(prev => ({ ...prev, error: 'Booking Cutoff must be an integer.' }));
            isValid = false;
        }
        if (!Number.isInteger(Route.cargoCutoff)) {
            setRoute(prev => ({ ...prev, error: 'Cargo Cutoff must be an integer.' }));
            isValid = false;
        }
        if (!Number.isInteger(Route.documentationCutoff)) {
            setRoute(prev => ({ ...prev, error: 'Documentation Cutoff must be an integer.' }));
            isValid = false;
        }
        if (Route.portDwellTime && !Number.isInteger(Number(Route.portDwellTime))) {
            setRoute(prev => ({ ...prev, error: 'Port Dwell Time must be an integer.' }));
            isValid = false;
        }

        // Validate new weekday fields
        const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        if (Route.etdWeekday && !weekdays.includes(Route.etdWeekday)) {
            setRoute(prev => ({ ...prev, error: errors.ETD_WEEKDAY_ERROR }));
            isValid = false;
        }
        if (Route.etaWeekday && !weekdays.includes(Route.etaWeekday)) {
            setRoute(prev => ({ ...prev, error: errors.ETA_WEEKDAY_ERROR }));
            isValid = false;
        }
        if (Route.cargoAvailabilityWeekday && !weekdays.includes(Route.cargoAvailabilityWeekday)) {
            setRoute(prev => ({ ...prev, error: errors.CARGO_AVAIL_WEEKDAY_ERROR }));
            isValid = false;
        }

        return isValid;
    };

    const handleSaveEditRoute = async (formType = 'edit') => { // Rename function
        if (!validateForm()) return;

        // Validate each carrier section before saving
        let isValid = true;
        const updatedSections = Route.carrierSections.map((section) => {
            if (!section.selectedCarrier || !section.selectedService) {
                isValid = false;
                return { ...section, validationError: 'Service and Carrier are required, otherwise delete this section' };
            }
            return { ...section, validationError: '' };
        });
        if (!isValid) {
            setRoute(prev => ({ ...prev, carrierSections: updatedSections }));
            return; // Abort saving if any section is invalid
        }

        // Function to convert time to HHMM
        const convertTo24Hour = ({ hh, mm, meridiem }) => {
            let hour = parseInt(hh, 10);
            const minute = parseInt(mm, 10);
            if (meridiem === 'PM' && hour < 12) hour += 12;
            if (meridiem === 'AM' && hour === 12) hour = 0;
            const formattedHour = hour.toString().padStart(2, '0');
            const formattedMinute = minute.toString().padStart(2, '0');
            return `${formattedHour}:${formattedMinute}:00`;
        };

        const data = {
            cfs_origins: Array.isArray(Route.cfsOrigins) ? Route.cfsOrigins.join(',') : (Route.cfsOrigins || ''),
            cfs_destinations: Array.isArray(Route.cfsDestinations) ? Route.cfsDestinations.join(',') : (Route.cfsDestinations || ''),
            port_of_loading: Route.selectedPortOfLoading,
            port_of_discharge: Route.selectedPortOfDischarge,
            port_dwell_time: Number(Route.portDwellTime),
            booking_cutoff_offset: Number(Route.bookingCutoff),
            cargo_cutoff_offset: Number(Route.cargoCutoff),
            documentation_cutoff_offset: Number(Route.documentationCutoff),
            etd_weekday: Route.etdWeekday || null,
            eta_weekday: Route.etaWeekday || null,
            cargo_availability_weekday: Route.cargoAvailabilityWeekday || null,
            carriers: Route.selectedCarrier, // Updated to single selection
            booking_closing_cutoffs: Array.isArray(Route.selectedBookingCutoffs) ? Route.selectedBookingCutoffs.join(',') : (Route.selectedBookingCutoffs || ''),
            cargo_closing_cutoffs: Array.isArray(Route.selectedCargoCutoffs) ? Route.selectedCargoCutoffs.join(',') : (Route.selectedCargoCutoffs || ''),
            documentation_closing_cutoffs: Array.isArray(Route.selectedDocumentationCutoffs) ? Route.selectedDocumentationCutoffs.join(',') : (Route.selectedDocumentationCutoffs || ''),
            services: Route.selectedService, // Updated to single selection
            booking_cutoff_time: convertTo24Hour(Route.bookingCutoffTime),
            cargo_cutoff_time: convertTo24Hour(Route.cargoCutoffTime),
            documentation_cutoff_time: convertTo24Hour(Route.documentationCutoffTime),
            routeType: Route.routeType, // Add the routeType to the request data
            effective_date: Route.effectiveDate,
            expiration_date: Route.expirationDate,
            carrier_sections: [
                {
                    carrier: Route.selectedCarrier,
                    service: Route.selectedService,
                    sailingPriority: Route.sailingPriority,
                    bookingCutoff: Route.bookingCutoff,           // main booking cutoff
                    cargoCutoff: Route.cargoCutoff,             // main cargo cutoff
                    documentationCutoff: Route.documentationCutoff,     // main documentation cutoff
                    bookingCutoffTime: convertTo24Hour(Route.bookingCutoffTime),       // main booking cutoff time
                    cargoCutoffTime: convertTo24Hour(Route.cargoCutoffTime),         // main cargo cutoff time
                    documentationCutoffTime: convertTo24Hour(Route.documentationCutoffTime), // main documentation cutoff time
                    etdWeekday: Route.etdWeekday,
                    etaWeekday: Route.etaWeekday,
                    cargoAvailabilityWeekday: Route.cargoAvailabilityWeekday,
                    portDwellTime: Route.portDwellTime
                    // ... add other main fields if needed ...
                },
                ...Route.carrierSections.map(section => ({
                    carrier: section.selectedCarrier,
                    service: section.selectedService,
                    sailingPriority: section.sailingPriority,
                    bookingCutoff: section.bookingCutoff,
                    cargoCutoff: section.cargoCutoff,
                    documentationCutoff: section.documentationCutoff,
                    bookingCutoffTime: convertTo24Hour(section.bookingCutoffTime),
                    cargoCutoffTime: convertTo24Hour(section.cargoCutoffTime),
                    documentationCutoffTime: convertTo24Hour(section.documentationCutoffTime),
                    etdWeekday: section.etdWeekday,
                    etaWeekday: section.etaWeekday,
                    cargoAvailabilityWeekday: section.cargoAvailabilityWeekday,
                    portDwellTime: section.portDwellTime
                    // ... include additional fields from section if required ...
                })),
            ],
        };
        console.log("Attempting to save with data:", { data, formType, routeType: Route.routeType });
        setRoute(prev => ({ ...prev, isSaving: true }));
        try {
            let response;
            if (formType === 'add') {
                // Use POST for creating new routes
                response = await axios.post('/api/routes-dcc', data);
                scrollToTop();
                if (response.status === 201 || response.status === 200) {
                    setSuccessMessage('Consol route was successfully created.');
                    setRoute(prev => ({ ...prev, error: '' }));
                    setTimeout(() => setSuccessMessage(''), 10000);
                    navigate(`/routing-guide/list?providerType=${providerType}`);
                } else {
                    setRoute(prev => ({ ...prev, error: 'Unexpected response from server.' }));
                }
            } else {
                // Use PUT for updating existing routes
                response = await axios.put(`/api/routes-dcc/${provider_guide_id}`, data);
                scrollToTop();
                if (response.status === 200) {
                    setRoute(prev => ({
                        ...prev,
                        successMessage: 'DCC route was successfully updated.',
                        error: ''
                    }));
                    /* Refresh route data */
                    fetchRouteData();
                    // navigate(`/routing-guide/list?providerType=${providerType}`);
                } else {
                    setRoute(prev => ({ ...prev, error: 'Unexpected response from server.' }));
                }
            }
        } catch (error) {
            const errorMessage = formType === 'add'
                ? 'Failed to create new route. Please try again.'
                : 'Failed to update route. Please try again.';

            setRoute(prev => ({ ...prev, error: error.response?.data?.error || errorMessage }));
            console.error(formType === 'add' ? 'Error creating route:' : 'Error updating route:', error);
        } finally {
            setRoute(prev => ({ ...prev, isSaving: false }));
        }
    };

    /* Fetches all port suggestions plus additional suggestions to handle "all of" ports from a given country */
    const fetchPortSuggestionsExtended = async (value, suggestionListName) => {
        try {
            const response = await axios.get('/api/port-names-by-uncode-or-name/extended', {
                params: { query: value },
                responseType: 'json'
            });
            if (response.headers['content-type'].includes('application/json')) {
                setRoute(prev => ({ ...prev, [suggestionListName]: response.data }));
            } else {
                throw new Error('Invalid response format');
            }
        } catch (error) {
            console.error('Error fetching port suggestions:', error);
        }
    };

    // Define the new function fetchPortSuggestionsForCFSPOL
    const fetchPortSuggestionsForCFSPOL = async (value) => {
        try {
            const response = await axios.get('/api/port-names-by-uncode-or-name-for-cfs-pol', {
                params: {
                    query: value || '%',
                    portOfLoad: Route.selectedPortOfLoading,
                    portOfDischarge: '%'
                    /* portOfDischarge is no longer being considered here 
                    portOfDischarge: selectedPortOfDischarge
                    */
                },
                responseType: 'json'
            });
            if (response.headers['content-type'].includes('application/json')) {
                setRoute(prev => ({
                    ...prev,
                    originSuggestions: response.data
                }));
            } else {
                throw new Error('Invalid response format');
            }
        } catch (error) {
            console.error('Error fetching CFS POL port suggestions:', error);
        }
    };

    // Define the new function fetchPortSuggestionsForCFSPOD
    const fetchPortSuggestionsForCFSPOD = async (value) => {
        try {
            const response = await axios.get('/api/port-names-by-uncode-or-name-for-cfs-pod', {
                params: {
                    query: value,
                    portOfLoad: Route.selectedPortOfLoading,
                    portOfDischarge: Route.selectedPortOfDischarge
                },
                responseType: 'json'
            });
            if (response.headers['content-type'].includes('application/json')) {
                setRoute(prev => ({
                    ...prev,
                    destinationSuggestions: response.data
                }));
            } else {
                throw new Error('Invalid response format');
            }
        } catch (error) {
            console.error('Error fetching CFS POD port suggestions:', error);
        }
    };


    const handleOpenCoLoadModal = async () => {
        try {
            console.log("handleOpenCoLoadModal called");
            const [preResponse, onResponse] = await Promise.all([
                axios.get('/api/fetch-all-pre-carriage-cfs-by-pol', { params: { pol: Route.selectedPortOfLoading } }),
                axios.get('/api/fetch-all-on-carriage-cfs-by-pod', { params: { pod: Route.selectedPortOfDischarge } })
            ]);
            const preCFSCodes = preResponse.data.map(item => item.cfs_code);
            const onCFSCodes = onResponse.data.map(item => item.cfs_code);

            console.log({ preCFSCodes, onCFSCodes });

            // Merge with any previously considered values ensuring uniqueness
            const newOrigins = [...new Set([...(Route.cfsOrigins || []), ...(preCFSCodes || [])])];
            const newDestinations = [...new Set([...(Route.cfsDestinations || []), ...(onCFSCodes || [])])];

            // Use newOrigins/newDestinations to compute combinations and update modal state:
            const combinations = getTokenizedCombinations(newOrigins, newDestinations, Route.selectedPortOfLoading, Route.selectedPortOfDischarge);
            setRoute(prev => ({
                ...prev,
                combinations,
                showCoLoadModal: true
            }));

        } catch (error) {
            console.error(error);
        }
    };

    const handleCloseCoLoadModal = () => {
        /* If conversionSuccess is true, navigate the user to the list page */
        if (Route.conversionSuccess) {
            navigate(`/routing-guide/list?providerType=${providerType}`);
        } else {
            setRoute(prev => ({ ...prev, showCoLoadModal: false }));
        }
    };


    const getTokenizedCombinations = (cfso, cfsd, pol, pod) => {
        console.log("Called getTokenizedCombinations()");
        console.log({ pol, pod, cfso, cfsd });
        let tokens = [];
        if (pol && pod) {
            tokens.push(`${pol} to ${pod}`);
        }
        /* Add a combination to cover all CFS origins to all CFS destinations */
        if ((cfso?.length || 0) && (cfsd?.length || 0)) {
            cfso.forEach(origin => {
                cfsd.forEach(dest => {
                    tokens.push(`${origin} to ${dest}`);
                });
            });
        }
        /* Add a combination to cover POL to all CFS destinations */
        if (pol && (cfsd?.length || 0)) {
            cfsd.forEach(dest => {
                tokens.push(`${pol} to ${dest}`);
            });
        }
        /* Add a combination to cover all CFS origins to POD */
        if ((cfso?.length || 0) && pod) {
            cfso.forEach(origin => {
                console.log("Adding combination:", `${origin} to ${pod} for CFS origins to POD`);
                tokens.push(`${origin} to ${pod}`);
            });
        }
        /* Add a combination to cover all POD to destination CFS */
        if ((cfsd?.length || 0) && pod) {
            cfsd.forEach(dest => {
                tokens.push(`${pod} to ${dest}`);
            });
        }
        return tokens;
    };


    const handleConvertToCoload = async (e) => {
        /* This came from a button click, get the button's label and declare is as `const buttonLabel` */
        const buttonLabel = e ? e.target.textContent : 'Default Button Label';
        /* If buttonLabel == 'Cancel Convert to Co-Load Route Request', then set const cancellationRequest to true */
        const cancellationRequest = buttonLabel === 'Cancel Convert to Co-Load Route Request';

        if (Route.converting === true) return; // Prevent running if already converting
        setRoute(prev => ({
            ...prev,
            converting: true,
            conversionError: ''
        }));

        try {
            /* Add validation that requires a coLoadProvider to be selected */
            if (!Route.selectedCoLoadProvider && !cancellationRequest) {
                throw new Error("Required: Please select a Co-Load Provider");
            }
            /* Add validation that if there are no combinations, then the user should be instructured to add at least a POL and a POD */
            if (!Route.combinations.length && !cancellationRequest) {
                throw new Error("Required: Please add at least a POL and a POD to convert to Co-Load routes");
            }
            /* Add validation that requires a conversion start date to be selected */
            if (!Route.selectedConversionStartDate && !cancellationRequest) {
                throw new Error("Required: Please select a Conversion Start Date");
            }
            console.log("Converting to Co-Load routes with data:", { selectedCoLoadProvider: Route.selectedCoLoadProvider, combinations: Route.combinations, conversionStartDate: Route.selectedConversionStartDate, cancellationRequest, provider_guide_id });
            const coLoadRoutes = Route.combinations && Route.combinations.length > 0 ? Route.combinations.map(port_pair => {
                /* Replace the ' to ' from the port pair */
                return port_pair.replace(' to ', '-');
            }) : [];
            const conversionStartDateFormatted = Route.selectedConversionStartDate
                ? (Route.selectedConversionStartDate instanceof Date
                    ? Route.selectedConversionStartDate.toISOString().split('T')[0]
                    : (() => {
                        const date = new Date(Route.selectedConversionStartDate);
                        return !isNaN(date.getTime()) ? date.toISOString().split('T')[0] : '';
                    })())
                : '';
            const response = await axios.post('/api/convert-to-coload-routes', {
                coLoadProvider: Route.selectedCoLoadProvider ? Route.selectedCoLoadProvider : null,
                coLoadRoutes: coLoadRoutes.join(','),
                conversionStartDate: conversionStartDateFormatted,
                provider_guide_id: provider_guide_id,
                cancellationRequest
            });

            if (cancellationRequest) {
                setRoute(prev => ({ ...prev, conversionCancellationSuccess: true }));
            } else {
                setRoute(prev => ({ ...prev, conversionSuccess: true }));
            }

        } catch (err) {
            console.log(err);
            const errorMessage = err.message.includes("Required:") ? err.message : "Error converting DCC to Co-Load routes";
            setRoute(prev => ({
                ...prev,
                conversionError: errorMessage,
                converting: false
            }));
        } finally {
            setRoute(prev => ({ ...prev, converting: false }));
        }
    };


    const allCarrierSectionsHaveCarriers = () => {
        return Route.carrierSections.every(section => section.availableCarriers.length > 0);
    };

    const fetchRouteData = async () => {
        try {

            /* If route_type is 'FUTURE', fetch data from GET '/api/routes/${provider_guide_id}/future' instead of GET '/api/routes/${provider_guide_id}' */
            /* The structure of the return data is exactly the same for both GET requests, so no need to change the rest of the code */

            console.log("Fetching route data. Route type:", route_type);
            console.log("Provider guide ID:", provider_guide_id);

            const response = await axios.get(route_type === 'FUTURE' ? `/api/routes/${provider_guide_id}/future` : `/api/routes/${provider_guide_id}`);
            const data = response.data;

            console.log("return data from fetchRouteData for route type:", route_type, ":", { data });

            setRoute(prev => ({
                ...prev, createRoute: {
                    origin: data.dcc_origin_port_code, // Updated property name
                    destination: data.dcc_destination_port_code, // Updated property name
                    carrier: data.dcc_carriers_list ? data.dcc_carriers_list.split(',') : [], // Updated property name
                    carrier_service_cutoffs: data.carrier_service_cutoffs
                }
            }));

            const initialCarrierSection = (data.carrier_service_cutoffs && data.carrier_service_cutoffs.length > 0)
                ? {
                    id: data.carrier_service_cutoffs[0].provider_guides_carrier_service_cutoff_id,
                    sailingPriority: data.carrier_service_cutoffs[0].carrier_service_priority_type,
                    selectedCarrier: data.carrier_service_cutoffs[0].carrier_scac,
                    availableCarriers: [...Route.availableCarriers],
                    selectedService: data.carrier_service_cutoffs[0].service_string,
                    availableServices: [...Route.availableServices],
                    bookingCutoff: parseInt(data.carrier_service_cutoffs[0].booking_offset_from_etd ?? 0),
                    cargoCutoff: parseInt(data.carrier_service_cutoffs[0].cargo_offset_from_etd ?? 0),
                    documentationCutoff: parseInt(data.carrier_service_cutoffs[0].documentation_offset_from_etd ?? 0),
                    bookingCutoffTime: setTimeFromString(data.carrier_service_cutoffs[0].booking_cutoff_time),
                    cargoCutoffTime: setTimeFromString(data.carrier_service_cutoffs[0].cargo_cutoff_time),
                    documentationCutoffTime: setTimeFromString(data.carrier_service_cutoffs[0].documentation_cutoff_time),
                    etdWeekday: data.carrier_service_cutoffs[0].pol_etd_weekday,
                    etaWeekday: data.carrier_service_cutoffs[0].pod_eta_weekday,
                    cargoAvailabilityWeekday: data.carrier_service_cutoffs[0].cargo_availability_at_dest_cfs_weekday,
                    portDwellTime: parseInt(data.carrier_service_cutoffs[0].port_dwell_time_days ?? 0)
                }
                : {
                    id: null,
                    sailingPriority: '',
                    selectedCarrier: '',
                    availableCarriers: [...Route.availableCarriers],
                    selectedService: '',
                    availableServices: [...Route.availableServices],
                    bookingCutoff: 0,
                    cargoCutoff: 0,
                    documentationCutoff: 0,
                    bookingCutoffTime: { hh: '12', mm: '00', meridiem: 'AM' },
                    cargoCutoffTime: { hh: '12', mm: '00', meridiem: 'AM' },
                    documentationCutoffTime: { hh: '12', mm: '00', meridiem: 'AM' },
                    etdWeekday: '',
                    etaWeekday: '',
                    cargoAvailabilityWeekday: '',
                    portDwellTime: 0
                };

            /* Now use the values from initialCarrierSection to populate the initial carrier section using the correct setters */
            setRoute(prev => ({
                ...prev,
                selectedCarrier: initialCarrierSection.selectedCarrier,
                selectedService: initialCarrierSection.selectedService,
                bookingCutoff: initialCarrierSection.bookingCutoff,
                cargoCutoff: initialCarrierSection.cargoCutoff,
                documentationCutoff: initialCarrierSection.documentationCutoff,
                bookingCutoffTime: initialCarrierSection.bookingCutoffTime,
                cargoCutoffTime: initialCarrierSection.cargoCutoffTime,
                documentationCutoffTime: initialCarrierSection.documentationCutoffTime,
                etdWeekday: initialCarrierSection.etdWeekday,
                etaWeekday: initialCarrierSection.etaWeekday,
                cargoAvailabilityWeekday: initialCarrierSection.cargoAvailabilityWeekday,
                portDwellTime: initialCarrierSection.portDwellTime
            }));

            /* Now iterate through the remaining carrier_service_cutoffs to populate additional carrier sections. */
            if (data.carrier_service_cutoffs && data.carrier_service_cutoffs.length > 1) {
                const additionalCarrierSections = data.carrier_service_cutoffs.slice(1).map((section, index) => ({
                    id: section.provider_guides_carrier_service_cutoff_id,
                    sailingPriority: section.carrier_service_priority_type,
                    selectedCarrier: section.carrier_scac,
                    availableCarriers: [...Route.availableCarriers],
                    selectedService: section.service_string,
                    availableServices: [],
                    bookingCutoff: parseInt(section.booking_offset_from_etd ?? 0),
                    cargoCutoff: parseInt(section.cargo_offset_from_etd ?? 0),
                    documentationCutoff: parseInt(section.documentation_offset_from_etd ?? 0),
                    bookingCutoffTime: setTimeFromString(section.booking_cutoff_time),
                    cargoCutoffTime: setTimeFromString(section.cargo_cutoff_time),
                    documentationCutoffTime: setTimeFromString(section.documentation_cutoff_time),
                    etdWeekday: section.pol_etd_weekday,
                    etaWeekday: section.pod_eta_weekday,
                    cargoAvailabilityWeekday: section.cargo_availability_at_dest_cfs_weekday,
                    portDwellTime: parseInt(section.port_dwell_time_days ?? 0)
                }));

                /* Populate the additional carrier sections */
                setRoute(prev => ({ ...prev, carrierSections: [...additionalCarrierSections] }));
            }

            /* populate origin, destination, and times */
            const origins = data.dcc_cfs_origin_list ? data.dcc_cfs_origin_list.split(',').map(code => code.trim()) : data.dcc_cfs_destination_list;
            const destinations = data.dcc_cfs_destination_list ? data.dcc_cfs_destination_list.split(',').map(code => code.trim()) : data.dcc_cfs_destination_list;

            setRoute(prev => ({
                ...prev,
                selectedPortOfLoading: data.origin_port_code,
                selectedPortOfDischarge: data.destination_port_code,
                cfsOrigins: origins,
                cfsDestinations: destinations,
                bookingCutoffTime: setTimeFromString(data.dcc_booking_cutoff_time),
                cargoCutoffTime: setTimeFromString(data.dcc_cargo_cutoff_time),
                documentationCutoffTime: setTimeFromString(data.dcc_documentation_cutoff_time),
                has_future_version: data.has_future_version,
                provider_guide_future_id: data.provider_guide_future_id,
                routeType: route_type,
                effectiveDate: data.effective_date ? new Date(data.effective_date) : null,
                expirationDate: data.expiration_date ? new Date(data.expiration_date) : null,
                routeNotFound: false,
                error: ''
            }));

            console.log("Route data fetched successfully:", { Route });

        } catch (error) {
            if (error.response && error.response.status === 404) {
                setRoute(prev => ({
                    ...prev,
                    error: `Route not found.`,
                    routeNotFound: true
                }));
            } else {
                setRoute(prev => ({ ...prev, error: 'Failed to load route data.' }));
            }

            console.error('Error fetching route data:', error);
        }
    };

    useEffect(() => {
        axios.get("/api/providers", { params: { providerType: "LCL" } })
            .then(response => setRoute(prev => ({ ...prev, coLoadProviders: response.data })))
            .catch(err => console.error("Failed to fetch Co-Load Providers:", err));
    }, []);

    useEffect(() => {
        /* Whenever the selectedPortOfLoading or selectedPortOfDischarge changes, check for the appropriate error messages to display based on what's missing */
        setRoute(prev => ({
            ...prev,
            missingPortOfLoadingError: !Route.selectedPortOfLoading ? 'Port of Loading is required' : '',
            missingPortOfDischargeError: !Route.selectedPortOfDischarge ? 'Port of Discharge is required' : ''
        }));
    }, [Route.selectedPortOfLoading, Route.selectedPortOfDischarge]);

    /* Fetch existing conversion requests for the selected provider guide ID */
    useEffect(() => {

        const fetchExistingConversionRequests = async () => {
            try {
                const response = await axios.get('/api/route-conversion-requests', {
                    params: {
                        provider_guide_id: provider_guide_id
                    }
                });
                if (response.data.length) {
                    /* Set the existing conversion request */
                    setRoute(prev => ({
                        ...prev,
                        existingConversionRequest: response.data[0],
                        selectedCoLoadProvider: response.data[0].provider_id,
                        selectedConversionStartDate: response.data[0].conversion_start_date
                    }));
                } else {
                    setRoute(prev => ({
                        ...prev,
                        existingConversionRequest: null,
                        selectedCoLoadProvider: '',
                        selectedConversionStartDate: ''
                    }));
                }
            } catch (error) {
                console.error('Error fetching existing conversion requests:', error);
            }
        };

        fetchExistingConversionRequests();

    }, [provider_guide_id, Route.conversionCancellationSuccess]);

    /* Fetch available services based on selected carrier, POL, and POD for each section */
    useEffect(() => {

        const fetchServices = async () => {
            /* Iterate over each section and fetch availableServices for each section's selectedCarrier */
            const servicesPromises = Route.carrierSections.map(section => {
                if (section.availableCarriers && section.availableCarriers.length > 0) {
                    console.log("Fetching services for:", { scac_code: section.selectedCarrier, pol: Route.selectedPortOfLoading, pod: Route.selectedPortOfDischarge });
                    return axios.get('/api/services-by-scac-and-pol-pod', {
                        params: { scac_code: section.selectedCarrier, pol: Route.selectedPortOfLoading, pod: Route.selectedPortOfDischarge },
                    });
                } else {
                    console.log("Available carriers is not yet set for section:", { section });
                    return Promise.resolve({ data: [] });
                }
            });

            const servicesResponses = await Promise.all(servicesPromises);
            const services = servicesResponses.map(response => response.data.map(service => service.service));
            console.log("Carrier services:", { carrierSections: Route.carrierSections });

            setRoute(prev => ({
                ...prev, carrierSections: prev.carrierSections.map((section, index) => ({
                    ...section,
                    availableServices: services[index]
                }))
            }));

        };

        const serviceValidation = async () => {
            setRoute(prev => ({
                ...prev, carrierSections: prev.carrierSections.map(section => {
                    /* If section.selectedService is not in section.availableServices, set section.missingServiceError message */
                    if (section.selectedService && section.availableServices && section.availableServices.length > 0) {
                        if (!section.availableServices.includes(section.selectedService)) {
                            return { ...section, missingServiceError: errors.VALID_SERVICE_ERROR };
                        } else {
                            return section;
                        }
                    } else {
                        return section;
                    }
                })
            }));
        };

        fetchServices().then(() => {

            serviceValidation();

        });

    }, [(Route.createRoute.carrier_service_cutoffs || []).length > 0 && Route.carrierSections.length == (Route.createRoute.carrier_service_cutoffs || []).slice(1).length && allCarrierSectionsHaveCarriers()]);

    /* Fetch available services based on selected carrier, POL, and POD */
    useEffect(() => {
        const fetchServices = async () => {

            if (!Route.selectedCarrier) {
                setRoute(prev => ({
                    ...prev,
                    availableServices: [],
                    selectedService: ''
                }));
                return;
            }

            try {
                const response = await axios.get('/api/services-by-scac-and-pol-pod', {
                    params: { scac_code: Route.selectedCarrier, pol: Route.selectedPortOfLoading, pod: Route.selectedPortOfDischarge },
                });
                const services = Array.isArray(response.data) ? response.data.map(service => service.service) : [];
                // Filter out any selected services that are no longer available
                setRoute(prev => ({ ...prev, availableServices: services }));
                setRoute(prev => ({ ...prev, selectedService: prev.availableServices.find(service => service == prev.selectedService) }));
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        };

        fetchServices();
    }, [Route.selectedCarrier, Route.selectedPortOfLoading, Route.selectedPortOfDischarge]);

    /* Whenever the selectedCarrier or selectedService changes, check if it's in availableCarriers or availableServices */
    useEffect(() => {
        console.log("Calling effect on selectedService change.");
        /* POL and POD are required to proceed */
        if (!Route.selectedPortOfLoading || !Route.selectedPortOfDischarge) {
            console.log("POL or POD missing. Skipping effect.");
            return;
        }

        /* If selectedPortOfLoading or selectedPortOfDischarge is less than 5 characters, skip the effect */
        if (Route.selectedPortOfLoading.length < 5 || Route.selectedPortOfDischarge.length < 5) {
            console.log("POL or POD is less than 5 characters. Skipping effect.");
            return;
        }

        /* Send an axios GET request to fetch the possible sailing days of the week from the POL to the POD on the selected Carrier and Service */
        const fetchSailingDays = async () => {
            try {
                const response = await axios.get('/api/carrier-service-pol-pod-weekdays-options', {
                    params: {
                        carrier: Route.selectedCarrier,
                        service: Route.selectedService,
                        pol: Route.selectedPortOfLoading,
                        pod: Route.selectedPortOfDischarge
                    }
                });
                const data = response.data;
                console.log({ data }, "Data received from carrier-service-pol-pod-weekdays-options");
                /* Use the data to populate the POL ETD Weekday and POD ETA Weekday dropdowns */

                /* Filter for data.side == 'POL' to populate poletdweekdayoptions */
                const polOptions = data.filter(item => item.side === 'POL').map(item => item.weekday);
                setRoute(prev => ({ ...prev, poletdweekdayoptions: polOptions }));

                /* Filter for data.side == 'POD' to populate podetaweekdayoptions */
                const podOptions = data.filter(item => item.side === 'POD').map(item => item.weekday);
                setRoute(prev => ({ ...prev, podetaweekdayoptions: podOptions }));


            } catch (error) {
                console.error('Error fetching sailing days:', error);
            }
        };

        console.log("Calling fetchSailingDays");
        fetchSailingDays();

    }, [Route.selectedPortOfLoading, Route.selectedPortOfDischarge, Route.selectedCarrier, Route.selectedService]);

    /* Fetch carriers based on selected POL and POD */
    useEffect(() => {
        if (!Route.selectedPortOfLoading || !Route.selectedPortOfDischarge) return;

        const fetchCarriers = async () => {
            try {
                console.log("Fetching carriers by pol and pod:", { selectedPortOfLoading: Route.selectedPortOfLoading, selectedPortOfDischarge: Route.selectedPortOfDischarge });
                const response = await axios.get('/api/supported-carriers-by-pol-pod', {
                    params: { pol: Route.selectedPortOfLoading, pod: Route.selectedPortOfDischarge },
                    responseType: 'json'
                });
                console.log("Supported carriers:", { response: response.data });
                setRoute(prev => ({ ...prev, availableCarriers: response.data }));
            } catch (error) {
                console.error('Error fetching providers:', error);
            }
        };

        fetchCarriers();
    }, [Route.selectedPortOfLoading, Route.selectedPortOfDischarge]);

    /* Whenever selectedCarrier changes, check if it's in availableCarriers */
    useEffect(() => {
        if (Route.availableCarriers.length > 0) {
            /* If selectedCarrier is not in availableCarriers, set missingCarrierError */
            if (!Route.availableCarriers.includes(Route.selectedCarrier)) {
                setRoute(prev => ({ ...prev, missingCarrierError: errors.VALID_CARRIER_ERROR }));
            } else {
                setRoute(prev => ({ ...prev, missingCarrierError: '' }));
            }
        } else {
            setRoute(prev => ({ ...prev, missingCarrierError: '' }));
        }
    }, [Route.selectedCarrier, Route.availableCarriers]);

    useEffect(() => {
        if (Route.selectedCarrier && Route.availableServices.length > 0) {
            /* if selectedService is not in availableServices, set missingServiceError */
            if (!Route.availableServices.includes(Route.selectedService)) {
                setRoute(prev => ({ ...prev, missingServiceError: errors.VALID_SERVICE_ERROR }));
            } else {
                setRoute(prev => ({ ...prev, missingServiceError: '' }));
            }
        } else {
            setRoute(prev => ({ ...prev, missingServiceError: '' }));
        }
    }, [Route.selectedCarrier, Route.selectedService, Route.availableServices]);

    useEffect(() => {
        (async () => {
            await fetchRouteData();
        })();
    }, [provider_guide_id]);

    return {
        Route,
        setRoute,
        fetchRouteData,
        handlePortOfLoadingSelect,
        handlePortOfDischargeSelect,
        handleCarrierServiceSection_ServiceChange,
        handleAddCarrierService,
        handleRemoveCarrierSection,
        toggleCutoffSection,
        setTimeFromString,
        validateForm,
        handleSaveEditRoute,
        fetchPortSuggestionsExtended,
        fetchPortSuggestionsForCFSPOL,
        fetchPortSuggestionsForCFSPOD,
        handleOpenCoLoadModal,
        handleCloseCoLoadModal,
        getTokenizedCombinations,
        handleConvertToCoload,
        allCarrierSectionsHaveCarriers
    };

};